import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "./LoaderSlice";
import {
  getPartnerComplianceLetterList,
  downloadPartnerLetters,
  sendPartneSignedLetter,
  sendNotificationForComplianceLetter,
} from "../../services";
import { showMessage } from "../../helpers";

// Create async thunks for API calls
export const getPartnerComplianceLetter = createAsyncThunk(
  "partnerComplianceLetter/getList",
  async (data, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await getPartnerComplianceLetterList(data);
      dispatch(hideLoader());
      return response || [];
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

export const downloadPartnerLetter = createAsyncThunk(
  "partnerComplianceLetter/download",
  async ({ filename, data }, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await downloadPartnerLetters(data);
      dispatch(hideLoader());
      if (response.url) window.open(response.url);
      return response;
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

export const sendPartnerSignedPDF = createAsyncThunk(
  "partnerComplianceLetter/sendSigned",
  async ({ data, onSuccess }, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await sendPartneSignedLetter(data);
      dispatch(hideLoader());
      if (onSuccess) {
        let formData = new FormData();
        formData.append("template_history_id", data.get("template_history_id"));
        onSuccess();
        sendNotificationForComplianceLetter(formData);
      }
      return response;
    } catch (error) {
      dispatch(hideLoader());
      showMessage("error", error.toString());
      throw error;
    }
  },
);

const initialState = {
  PartnerComplianceLetterList: [],
  isLoaded: false,
};

const partnerComplianceLetterSlice = createSlice({
  name: "partnerComplianceLetter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Partner Compliance Letter List
      .addCase(getPartnerComplianceLetter.pending, (state) => {
        state.isLoaded = false;
      })
      .addCase(getPartnerComplianceLetter.fulfilled, (state, action) => {
        state.isLoaded = true;
        state.PartnerComplianceLetterList = action.payload;
      })
      .addCase(getPartnerComplianceLetter.rejected, (state) => {
        state.isLoaded = true;
      })

      // Download Partner Letter
      .addCase(downloadPartnerLetter.pending, (state) => {
        // No state change needed
      })
      .addCase(downloadPartnerLetter.fulfilled, (state) => {
        // No state change needed
      })
      .addCase(downloadPartnerLetter.rejected, (state) => {
        // No state change needed
      })

      // Send Partner Signed Letter
      .addCase(sendPartnerSignedPDF.pending, (state) => {
        // No state change needed
      })
      .addCase(sendPartnerSignedPDF.fulfilled, (state) => {
        // No state change needed
      })
      .addCase(sendPartnerSignedPDF.rejected, (state) => {
        // No state change needed
      });
  },
});

export default partnerComplianceLetterSlice.reducer;
